import { useMutation } from '@tanstack/react-query';
import { postPayin } from 'api/resources/payin';

export const usePostPayin = () => {
	return useMutation({
		mutationFn: postPayin,
	});
};
